<template>
  <div class="text">
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <div class="add-text">
        <div
          class="add-title"
          :style="titleStyle"
          @click="
            addText('title');
            materialPushAnalysis({ type: 'text3' });
          "
        >
          添加标题
        </div>
        <div
          class="add-subtitle"
          :style="subtitleStyle"
          @click="
            addText('subtitle');
            materialPushAnalysis({ type: 'text2' });
          "
        >
          添加副标题
        </div>
        <div
          class="add-body-text"
          :style="textStyle"
          @click="
            addText('content');
            materialPushAnalysis({ type: 'text1' });
          "
        >
          添加正文
        </div>
        <div class="add-rich-text" @click="addRichText()">
          <span style="font-size: 15px">选中</span>
          <span>文字修改局部</span>
          <span style="font-size: 18px; color: #5778fb">大</span>
          <span>小／</span>
          <span style="color: #5778fb">颜色</span>
        </div>
      </div>

      <textArtStyle v-model="judgetextArtStyle" />

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="{ operation: dataArray['_' + item.id].judge }"
        :style="{ height: dataArray['_' + item.id].judge ? 'auto' : '146px' }"
      >
        <sectionCategory
          :itemData="item"
          :itemIndex="index"
          :boxName="boxName"
          @click="judgetextArtStyle = false"
          @scrollTop="scrollTop"
          @getData="getData"
          @dataBoxAction="dataBoxAction"
        />

        <div
          class="body-list"
          :style="{
            height: dataArray['_' + item.id].data.length
              ? dataArray['_' + item.id].WFSheight + 30 + 'px'
              : '150px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top': dataArray['_' + item.id].data.length
              ? dataArray['_' + item.id].WFSheight - 10 + 'px'
              : '50px',
          }"
        >
          <FilterSprites
            v-model="dataArray['_' + item.id]"
            :boxName="boxName"
            :cgid="'_' + item.id"
            :dataArray="dataArray"
            :loading="loading"
          />

          <div
            class="item"
            v-for="(itemL, indexL) in dataArray['_' + item.id].data"
            :key="itemL.id"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
              @click="
                materialPushAnalysis({
                  type: 'text',
                  id: item.id,
                  name: item.name,
                });
                slidAddSprites(itemL);
              "
            />

            <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
            <payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 50px"
          ></div>
        </div>

        <div class="bottom-more">
          <div class="btn" @click="callSpriteLib()">更多文字</div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg == 'text'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />

      <div class="colorPickerGrid" v-if="isSettingColor">
        <ColorPickerSlide :boxName="boxName"></ColorPickerSlide>
      </div>
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="slidAddSprites"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import textArtStyle from "./search/textStyle";
import Search from "./search/search";
import ColorPickerSlide from "./colorPickerSlide.vue";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      boxName: "text", // 素材盒子的名字
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 275, // 默认添加的高度 - 140
        Incremental: 140, // 单个分类的高度
        material: 95, // 单个元素的高度
        materialW: 94, // 单个元素的宽
        rowNum: 3, // 每行个数
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 16,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      user: false,
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 3, // 瀑布流的列数
      },
      judgetextArtStyle: {
        // 艺术字体的判断数据
        judge: false,
      },
      isSettingColor: false,
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "Window_Size",
      "Tool_Size",
      "TOOL",
      "SpriteOperation",
      "SpriteBeforeSwap",
      "textOption",
    ]),
    titleStyle() {
      const style = {};
      Object.assign(style, this.textOption.title.font, {
        fontSize: "30px",
        fontFamily: `"${this.textOption.title.font.fontFamilyUrl
          .split("/")
          .pop()}"`,
      });
      return style;
    },
    subtitleStyle() {
      const style = {};
      Object.assign(style, this.textOption.subtitle.font, {
        fontSize: "20px",
        fontFamily: `"${this.textOption.subtitle.font.fontFamilyUrl
          .split("/")
          .pop()}"`,
      });
      return style;
    },
    textStyle() {
      const style = {};
      Object.assign(style, this.textOption.content.font, {
        fontSize: "14px",
        fontFamily: `"${this.textOption.content.font.fontFamilyUrl
          .split("/")
          .pop()}"`,
      });
      return style;
    },
  },
  watch: {
    "judgetextArtStyle.judge": function (val, oldval) {
      // 关键词搜索事件
      if (this.judgetextArtStyle.judge) {
        this.dataBoxAction();
      }
    },
  },
  mounted() {},
  methods: {
    addText(text) {
      if (this.SpriteOperation === "swap") {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
        this.TOOL.swapSprite(
          {
            sprite,
            typeForAdd: "Text",
            optionForAdd: this.textOption[text],
          },
          true
        );
        return;
      }
      console.log(this.textOption[text].font, "<---------12");
      this.TOOL.addSprite(
        "Text",
        {
          text: this.textOption[text].text,
          font: this.textOption[text].font,
          resourceId: this.textOption[text].fontId,
        },
        null,
        true
      );
      // switch (text) {
      //   case "title":
      //     this.TOOL.addSprite(
      //       "Text",
      //       {
      //         text: "添加标题",
      //         font: {
      //           fontSize: 80,
      //           color: "#303233",
      //           fontWeight: "bold",
      //           fontFamily: "2018-5-16/1526467728442.TTF",
      //           textAlign: "center"
      //         }
      //       },
      //       null,
      //       true
      //     );
      //     break;
      //   case "subtitle":
      //     this.TOOL.addSprite(
      //       "Text",
      //       {
      //         text: "添加副标题",
      //         font: {
      //           fontSize: 65,
      //           color: "#303233",
      //           fontWeight: "bold",
      //           fontFamily: "2018-5-16/1526467728442.TTF",
      //           textAlign: "center"
      //         }
      //       },
      //       null,
      //       true
      //     );
      //     break;
      //   case "content":
      //     this.TOOL.addSprite(
      //       "Text",
      //       {
      //         text: "添加正文",
      //         font: {
      //           fontSize: 50,
      //           color: "#303233",
      //           fontWeight: "normal",
      //           fontFamily: "2018-5-16/1526467728442.TTF",
      //           textAlign: "center"
      //         }
      //       },
      //       null,
      //       true
      //     );
      //     break;
      // }
    },
    addRichText() {
      this.TOOL.addSprite("RichText", {
        html:
          '<span style="font-size: 50px;">选中</span><span>文字修改局部</span><span style="font-size: 60px;color: #5778fb;">大</span><span>小／</span><span style="color: #5778fb;">颜色</span>',
        versionAnyway: "Horizontal",
        maxSize: 60,
      });
    },
  },
  components: {
    Search,
    textArtStyle,
    ColorPickerSlide,
    PayTypeSubscript,
  },
};
</script>

<style scoped lang="scss">
.text {
  width: 270px;
  .colorPickerGrid {
    position: absolute;
    top: 45px;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 50;
  }

  .add-text {
    width: 270px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 2px solid #d4d4e7;
    .add-title,
    .add-subtitle,
    .add-body-text {
      color: #474261;
      width: 160px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        color: #5778fb;
      }
    }
    .add-title {
      font-size: 30px;
      font-weight: bold;
      align-items: flex-start;
    }
    .add-subtitle {
      font-size: 20px;
      font-weight: bold;
      border-top: 1px solid #d4d4e7;
      border-bottom: 1px solid #d4d4e7;
    }
    .add-body-text {
      font-size: 14px;
      border-bottom: 1px solid #d4d4e7;
    }
    .add-rich-text {
      width: 200px;
      height: 45px;
      line-height: 45px;
      font-size: 13px;
      color: #474261;
      cursor: pointer;
    }
  }

  .data-body {
    padding: 22px 0;
    height: 146px;
    overflow: hidden;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;

      &:before {
        content: "";
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }

      .item {
        width: 80px;
        height: 80px;
        border-radius: 3px;
        position: absolute;
        cursor: pointer;
        background-color: #fafafd;
        border: solid 2px #dbdff0;
        overflow: hidden;

        &:hover {
          border-color: #5778fb;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 0;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }

        .modify,
        .label {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .modify {
          width: 35px;
          height: 35px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.3s;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
    }
  }
}

@import "./slide.scss";
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/text.vue